<template>
  <div>
    <el-card>
      <el-alert title="官网首页" type="info" center show-icon :closable='false'> </el-alert>
      <!-- 横幅图 -->
      <h3 class="bannerImages">官网首页轮播图<span style="font-size:14px;margin-left:20px;color:red;">注:请上传大小一致的图片</span></h3>
      <div class="backgroundImgUploads">
        <div class="backgroundImgList" v-for="item in bannerList" :key="item.id" @click="selectBannerImage(item.url)">
            <img :src="item.url" alt="">
            <div class="elIconDelete" @click.stop="deleteBanner(item.id)"><i class="el-icon-delete"></i></div>
        </div>
        <el-upload
            action="string"
            list-type="picture-card"
            :http-request="addBanner"
            accept=".png,.jpg,.jpeg"
            :show-file-list="false">
            <i class="el-icon-plus"></i>
        </el-upload>
      </div>
      <!-- 首页轮播图 -->
      <div class="certifybox">
        <h3 class="certifyImages">官网首页轮播图</h3>
        <el-upload
            action="string"
            list-type="picture-card"
            :http-request="addCertify"
            accept=".png,.jpg,.jpeg"
            :show-file-list="false">
            <i class="el-icon-plus"></i>
        </el-upload>
      </div>
      <div class="CertifyBackgroundImgUploads">
        <div class="backgroundImgList" v-for="(item,index) in certifyList" :key="item.id" @click="selectBannerImage(item.url)">
            <img :src="item.url" alt="">
            <div>
              <el-input v-model="certifyList[index].desc" @blur="updateCertify(item)"></el-input>
            </div>
            <div class="elIconDelete" @click.stop="deleteCertify(item.id)"><i class="el-icon-delete"></i></div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getAdminBannerList, deleteBanner, addBanner, addCertify, deleteCertify, getAdminCertifyList, updateCertify } from '@/api/editHome'
export default {
  data () {
    return {
      bannerList: [],
      certifyList: []
    }
  },
  created () {
    this.getBannerList()
    this.getCertifyList()
  },
  methods: {
    // 放大图片
    selectBannerImage (url) {

    },
    // 获取轮播图列表
    getBannerList () {
      getAdminBannerList().then(res => {
        if (res.code == 0) {
          this.bannerList = res.data
        } else {
          this.$message.error('获取官网横幅图失败！')
        }
      })
    },
    // 删除轮播图
    deleteBanner (id) {
      deleteBanner(id).then(res => {
        if (res.code == 0) {
          this.$message.success('删除成功')
          this.getBannerList()
        } else {
          this.$message.error('删除失败！')
        }
      })
    },
    // 添加轮播图
    addBanner (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      addBanner(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.getBannerList()
        }
      })
    },
    // 获取企业荣誉轮播图
    getCertifyList () {
      getAdminCertifyList().then(res => {
        if (res.code == 0) {
          this.certifyList = res.data
        } else {
          this.$message.error('获取官网轮播图失败！')
        }
      })
    },
    // 删除企业荣誉轮播图
    deleteCertify (id) {
      deleteCertify(id).then(res => {
        if (res.code == 0) {
          this.$message.success('删除成功')
          this.getCertifyList()
        } else {
          this.$message.error('删除失败！')
        }
      })
    },
    // 添加企业荣誉轮播图
    addCertify (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      addCertify(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.getCertifyList()
        }
      })
    },
    // 更新首页轮播图描述
    updateCertify (item) {
      var certify = item
      updateCertify(certify).then(res => {

      })
    }
  }
}
</script>

<style lang="less" scoped>
.bannerImages{
  margin: 25px;
}
.backgroundImgUploads{
  display: flex;
  margin: 20px;
  overflow-x: auto;
  .backgroundImgList{
    width: 258px;
    height: 174px;
    position: relative;
    margin-right: 2px;
    img{
        width: 258px;
        height: 174px;
        cursor: pointer;
    }
    .elIconDelete{
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 24px;
        cursor: pointer;
    }
  }
}
.certifybox{
  display: flex;
  margin: 35px 35px 0px 35px;
}
.CertifyBackgroundImgUploads{
  width: 1350px;
  margin: 20px auto;
  .backgroundImgList{
    float: left;
    width: 380px;
    height: 300px;
    position: relative;
    margin: 10px 35px;
    img{
        width: 380px;
        height: 250px;
        cursor: pointer;
    }
    .elIconDelete{
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 24px;
        cursor: pointer;
    }
  }
}
/deep/ .el-upload--picture-card{
  height: 174px;
  line-height: 174px;
  width: 258px;
}
.certifybox{
  /deep/ .el-upload--picture-card{
    height: 60px;
    line-height: 60px;
    width: 120px;
    margin-left: 20px;
  }
}
</style>
